module.exports = "/_next/static/images/d43a981787c58837a7334be0e150552e-Nubank_HickDuarte_58741_md.jpg";